import type { Location } from 'react-router-dom';

const BOOKING_PANEL_PATTERN = /.*\/config\/(.*)/;
const ITINERARY_PATTERN = /.*\/itinerary\/(.*)/;

export const isFlightsBookingPanelScreen = (location: Location): boolean =>
  !!(
    location &&
    (BOOKING_PANEL_PATTERN.test(location.pathname) || ITINERARY_PATTERN.test(location.pathname))
  );
